import {ALL_TOPIC_TYPES} from "../../paths";
import {toInternalPath} from "../../utils/dibUrls";
import {metricUuid} from "./metrics";

/** Only recognized topic routes carry a topic identity; portal landing pages do not. */
export function topicOpenFromUrl(href: string | null | undefined) {
    const path = href && toInternalPath(href);
    if (!path) return null;
    const [topicType, , rawId] = new URL(path, "https://app.dib.no").pathname.split("/").filter(Boolean);
    if (!ALL_TOPIC_TYPES.has(topicType)) return null;
    const key = metricUuid(rawId);
    return key ? {entity: "topic" as const, key, topicType} : null;
}
